var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4228 9.9478V7.8008C16.4228 5.2878 14.3848 3.2498 11.8718 3.2498C9.35876 3.2388 7.31276 5.2668 7.30176 7.7808V7.8008V9.9478",
    stroke: "#ADB5BD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.683 21.7497H8.042C5.948 21.7497 4.25 20.0527 4.25 17.9577V13.6687C4.25 11.5737 5.948 9.87671 8.042 9.87671H15.683C17.777 9.87671 19.475 11.5737 19.475 13.6687V17.9577C19.475 20.0527 17.777 21.7497 15.683 21.7497Z",
    stroke: "#ADB5BD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8623 14.7026V16.9236",
    stroke: "#ADB5BD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.af331d9bff45e308d763e2ddba0c957e.svg";
export { ForwardRef as ReactComponent };